import Controller from '@ember/controller';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
export default class MarketSettingsController extends Controller {
  @service declare access: Services['access'];
  @service declare currencyConversion: Services['currency-conversion'];
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];
  @service declare router: Services['router'];
  /* Disable unused service linting rule for theme service as it is used in the template */
  /* eslint-disable-next-line ember/no-unused-services */
  @service declare theme: Services['theme'];
  @service declare usageAnalytics: Services['usage-analytics'];

  @tracked isSettingsDrawerOpen = true;

  get hasBusinessIntelligenceGroup(): boolean {
    return (
      this.hasBusinessIntelligenceTab ||
      this.hasTransactionMapping ||
      this.hasPropertyTags ||
      this.hasCurrencyConversion
    );
  }

  get hasBusinessIntelligenceTab(): boolean {
    return (
      this.access.hasSpiderMarketEdit && !this.hotelAndMarketService.isMyHotels
    );
  }

  get hasCentralMapping(): boolean {
    return this.access.hasCentralMapping;
  }

  get hasCurrencyConversion(): boolean {
    return this.currencyConversion.hasCurrencyConversionAccess;
  }

  get hasGeneralGroup(): boolean {
    return (
      this.access.hasFeature('settings.hotel_access.edit') ||
      this.access.hasFeature('reports.view.settings') ||
      this.hasCentralMapping
    );
  }

  get hasPersonalSettingsGroup(): boolean {
    return (
      this.access.hasPersonalSettingsTab ||
      this.access.canEditPersonalSettingsPassword
    );
  }

  get hasPropertyTags(): boolean {
    return this.access.hasPropertyTags;
  }

  get hasTransactionMapping(): boolean {
    return this.access.hasTransactionMapping;
  }

  get isCentralMappingTabActive(): boolean {
    return Boolean(
      this.router?.currentRouteName?.includes(
        'market.settings.central-mapping',
      ),
    );
  }

  get isCurrencyConversionTabActive(): boolean {
    return Boolean(
      this.router?.currentRouteName?.includes(
        'market.settings.currency-conversion',
      ),
    );
  }

  @action onClickCentralMappingTab(): void {
    if (this.hasCentralMapping && !this.isCentralMappingTabActive) {
      this.usageAnalytics.track('Mapping Menu Page Opened', {
        eventTrigger: 'pms-mapping-settings',
        product: 'central-mapping',
      });
    }
  }

  @action onClickCurrencyConversionTab(): void {
    if (this.hasCurrencyConversion && !this.isCurrencyConversionTabActive) {
      this.usageAnalytics.track('Currency Settings Page Opened', {
        eventTrigger: 'currency-settings',
        product: 'custom-currency',
      });
    }
  }

  @action toggleNavbar(): void {
    this.isSettingsDrawerOpen = !this.isSettingsDrawerOpen;
  }
}
